/* Component rendered on the ScenesPage to display the 
   cover info for each Scene
 * When clicked on it opens that Scenes's ScenePage */
import React from "react";

import { Col, Row } from "react-bootstrap";
import Card from "react-bootstrap/Card";
import { Link, useHistory } from "react-router-dom";
import { axiosInstance, axiosReq } from "../../api/axiosDefaults";
import mo2a from "../../assets/mo2a.png";
import { PostDropAdminOnly } from "../../components/PostDropdown";
import { useCurrentUser } from "../../contexts/CurrentUserContext";
import { CLIENT_PROGRAM_HOSTNAME } from "../../utils/config";
import useHostName from "../../hooks/useHostName";
import toast from "react-hot-toast";
import styles from "../../styles/Scene.module.css";

const SceneTop = (props) => {
  const host = useHostName();
  const {
    id,
    fetchScenes,
    number,
    title,
    action,
    int_ext,
    location,
    day_night,
    style,
    epi,
    pro,
    episodeTitle,
    projectType,
  } = props;
  const currentUser = useCurrentUser();
  const history = useHistory();

  const handleEdit = () => {
    if (projectType === "Television") {
      history.push(
        `/${localStorage.getItem(
          "projectSlug"
        )}/scenes/${id}/edit?episode=${epi}&project=${pro}&episodeTitle=${episodeTitle}`
      );
    } else {
      history.push(`/${localStorage.getItem("projectSlug")}/scenes/${id}/edit`);
    }
  };

  const handleDelete = async () => {
    try {
      if (host === CLIENT_PROGRAM_HOSTNAME) {
        await axiosReq.delete(`/scenes/${id}/`);
        toast.success(`Scene Deleted`);
        fetchScenes();
      } else {
        await axiosInstance.delete(
          `${localStorage.getItem("projectSlug")}/scenes/${id}/`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            withCredentials: true,
          }
        );
        fetchScenes();
        toast.success(`Scene Deleted Successfully!`);
      }
    } catch (err) {}
  };

  return (
    <div >
      <Card style={{maxWidth: "400px"}} className={`text-center ${styles.SceneCard}`} >
        <div className={`mb-0 px-2 py-1`}>
          <Row className={`py-1 my-0 text-center`}>
            <Col className="mx-0 px-0" xs={1}></Col>
            <Col xs={10} className="mx-0 px-0 d-flex align-items-center justify-content-center">
              <Link
                to={
                  projectType === "Television"
                    ? `/${localStorage.getItem(
                        "projectSlug"
                      )}/scenes/${id}?episode=${epi}&project=${pro}&episodeTitle=${episodeTitle}`
                    : `/${localStorage.getItem("projectSlug")}/scenes/${id}`
                }
              >
                <div>
                  <h5 className={` ${styles.Grey}`}>Scene {number}</h5>
                </div>
              </Link>
            </Col>
            <Col xs={1} className={`mx-0 px-0`}>
            </Col>
          </Row>
          <Link
            to={
              projectType === "Television"
                ? `/${localStorage.getItem(
                    "projectSlug"
                  )}/scenes/${id}?episode=${epi}&project=${pro}&episodeTitle=${episodeTitle}`
                : `/${localStorage.getItem("projectSlug")}/scenes/${id}`
            }>
            <div className={` ${styles.Div20}`}>
            <Row>
            <Col xs={12} >
            <p className={styles.Italics}>{title}</p>
            </Col>
            </Row>
            </div>
          </Link>
        </div>
        {/* Body style={style} */}
        <Card.Body className="py-1 px-0"
        style={{
          backgroundImage: `url(${mo2a})`,
          objectFit: "contain",
          height: "100px",
          width: "auto",
          repeat: "no-repeat",
        }}
        >
          <Link to={
              projectType === "Television"
                ? `/${localStorage.getItem(
                    "projectSlug"
                  )}/scenes/${id}?episode=${epi}&project=${pro}&episodeTitle=${episodeTitle}`
                : `/${localStorage.getItem("projectSlug")}/scenes/${id}`}
          >
              <Row>
                <Col
                className={`px-3`}>
                <div className={` ${styles.Div10} px-0`}></div>              
                <div className={` ${styles.Div50} px-1`}>
                <p className={` ${styles.Grey3}`}>{location}</p>
                </div>
                <div className={` ${styles.Div25}`}>
                <Row>
                <Col xs={{span: 8, offset: 2}} >
                <p className={` ${styles.Grey4}`}>{action}</p>
                </Col>
                </Row>
                </div>
                </Col>
              </Row>
          </Link>
        </Card.Body>
        {/* date */}
            <Card.Body className={`${styles.Datetext } px-0 py-0 mx-0 my-0`}>
            <Row className={`px-3 d-flex align-items-center`}>     
            <Col xs={5} className='px-0'>
            <p style={{ textTransform: 'uppercase' }} 
            className={`${styles.Date2} pl-2 float-left`}>
            {int_ext}
            </p>
            </Col>       
            <Col xs={2} className={`${styles.Icon } text-center px-0 `} >
              {currentUser &&
                currentUser?.groups.length > 0 &&
                (currentUser?.groups[0]?.name === "Admin" ||
                  currentUser?.groups[0]?.name === "Superadmin" ||
                  currentUser?.groups[0]?.name === "Admincreative") && (
                  <PostDropAdminOnly
                    handleEdit={handleEdit}
                    handleDelete={handleDelete}
                  />
                )}
            </Col>
            <Col className="px-0" xs={5} >
            <p className={`float-right pr-2 ${styles.Date2}`}>{day_night}</p>
            </Col>
            </Row>  
            </Card.Body>
      </Card>
    </div>
  );
};

export default SceneTop;
